import Lottie from "lottie-web";

class Loader {
    constructor($el){
        this.$el = $el;
        this.json = $el.data('json');
        this.body = $('body');

        if(!sessionStorage.getItem('loaderCompleted')){
        this.init();
        }

        else {
            this.body.addClass('ready');
                this.$el.remove();
                window.CookieConsent.show();
        }
    }

   init = () => {
    this.lottie = Lottie.loadAnimation({
        container: this.$el[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: this.json,
    });

    const lottie = this.lottie;

    lottie.play();

    lottie.addEventListener('complete', () => {
        this.body.addClass("ready");
        this.$el.remove();
        sessionStorage.setItem('loaderCompleted', 'true');
        window.CookieConsent.show();

    });

};

    


}

export default Loader;